// extracted by mini-css-extract-plugin
export var addressFields = "_mu-0";
export var animationContainer = "_mu-1";
export var footer = "_mu-2";
export var lineItems = "_mu-3";
export var modalContent = "_mu-4";
export var orderName = "_mu-5";
export var strong = "_mu-6";
export var warning = "_mu-7";